import { Box, Button, Grid2, styled } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { useImageContext } from '../../imageContext';
import { useGetToken } from '../../hooks/useGetToken';
import { fbGetImageUrl } from '../../services/service';
import Context from '../../context';

const ActionContainerGrid = styled(Grid2)({
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  paddingRight: '10px',
  marginTop: '10px',
});

const ButtonContainerBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-around',
  marginTop: '20px',
});

const ImageTopGrid = styled(Grid2)({
  height: '200px',
  maxHeight: '200px',
  paddingRight: '10px',
  width: '90%',
});

const ImageGrid = styled(Grid2)({
  height: '220px',
  maxHeight: '220px',
  border: '1px solid lightgray',
  borderRadius: '3px',
  width: '100%',
  objectFit: 'scale-down',
  backgroundColor: '#FFFFFF',
});

const ButtonStyled = styled(Button)({
  borderRadius: '24px',
  padding: '6px 50px',
});

export interface ReferenceImagePreviewProps {
  readOnly: boolean | undefined;
  onAddImage: (image: string) => void;
  onRemoveImage: (image: string) => void;
  selectedImages: string[];
}

export const ReferenceImagePreview = (props: ReferenceImagePreviewProps): JSX.Element => {
  const {
    selected,
    setSelected,
    imageUrl,
    setImageUrl,
    questionImage,
    setTimestamp,
  } = useImageContext();
  const [getTokenFunction] = useGetToken();

  const {
    updateIsLoading, setShowError, setMessage
  } = useContext(Context);

  const resetDisabled = selected === '' || !props.selectedImages.includes(selected) || props.readOnly;
  const setDisabled = selected === '' || props.selectedImages.includes(selected) || props.readOnly;

  if (selected === '' || selected.endsWith('/')) {
    setImageUrl('');
  }

  useEffect(() => {
    const getImageUrl = async () => {
      try {
          updateIsLoading(true);
          setImageUrl('');
          const accessToken = await getTokenFunction();
          const imageUrl = await fbGetImageUrl(selected, false, accessToken);
          if (imageUrl) {
            setImageUrl(imageUrl);
          }
        } catch (e) {
          setMessage(`fbGetImageUrl ${e}`);
          setShowError(true);
      } finally {
        updateIsLoading(false);
      }
    };

    if (selected.length > 0) {
      getImageUrl();
    }
//  }, [selected]);
}, [selected, questionImage]);

  const hasImage = imageUrl.length > 0;

  return (
    <>
      <ImageTopGrid container >
        <ImageGrid>
          <Box display={'flex'} justifyContent={'center'} alignItems={'center'} paddingTop={'10px'}>
            {hasImage ? (
              <img
                id={`image-${new Date().getTime()}`}
                src={imageUrl.includes(selected) ? imageUrl : ''}
                style={{
                  height: '200px',
                  maxHeight: '200px',
                  border: '1px solid lightgray',
                  borderRadius: '3px',
                  width: '90%',
                  objectFit: 'scale-down',
                  paddingRight: '10px',
                }}
              />
            ) : (
              <br />
            )}
          </Box>
        </ImageGrid>
      </ImageTopGrid>
      <Grid2 container>
        <ActionContainerGrid>
          <ButtonContainerBox>
            <ButtonStyled
              disabled={resetDisabled}
              data-testid="image-reset-button"
              variant="contained"
              onClick={() => {
                props.onRemoveImage(selected)
//                setQuestionDeleteImage('');
                setSelected('');
                setTimestamp(`${new Date().toISOString()}`);
      }}
            >
              Remove
            </ButtonStyled>
            &nbsp;
            <ButtonStyled
              disabled={setDisabled}
              data-testid="image-set-button"
              variant="contained"
              onClick={() => {
                props.onAddImage(selected);
                setTimestamp(`${new Date().toISOString()}`);
              }}
            >
                Set
            </ButtonStyled>
          </ButtonContainerBox>
        </ActionContainerGrid>
      </Grid2>
    </>
  );
};
